const n = {
  name: "Berlin",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 6.08296V0H11V6.08296C8.16229 6.55904 6 9.027 6 12C6 14.2208 7.2066 16.1599 9 17.1973V19H8V21H9V24H11V21H13V24H15V21H16V19H15V17.1973C16.7934 16.1599 18 14.2208 18 12C18 9.027 15.8377 6.55904 13 6.08296ZM11 19V17.917C11.3252 17.9716 11.6593 18 12 18C12.3407 18 12.6748 17.9716 13 17.917V19H11ZM12 8C14.2091 8 16 9.79086 16 12H8C8 9.79086 9.79086 8 12 8ZM8.53513 14H15.4649C14.7733 15.1956 13.4806 16 12 16C10.5194 16 9.22675 15.1956 8.53513 14Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as Berlin
};
